import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { EnquirySection } from './components/EnquirySection';
import { VideoVisitSection } from './components/VideoVisitSection';
import { CtaBanner } from './components/CtaBanner';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-full w-full bg-[#f4f6f8] font-['Geist',sans-serif] text-slate-800" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <StatsBar data-id="element-4" />
        <EnquirySection data-id="element-5" />
        <VideoVisitSection data-id="element-6" />
        <CtaBanner data-id="element-7" />
      </main>
      <Footer data-id="element-8" />
    </div>;
}